import { generateUUID } from "syf-js-utilities";
var getCorrelationId = function () {
    var correlationId = sessionStorage.getItem("correlationId");
    if (!correlationId) {
        correlationId = generateUUID();
        sessionStorage.setItem("correlationId", correlationId);
    }
    return correlationId;
};
export default getCorrelationId;
